export default __webpack_public_path__ + "static/media/talent_finder.f84b7a0a.svg";